<template>
    <div class="item-4 mark" :style="`position: relative;z-index :${z_index}`">
        <div class="blueBg TitleSize" v-if="isShow">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{{title2}}</p>
            <!-- <p>总算力{{number1}}P</p> -->
        </div>
        <div class="blueBg1 TitleSize">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{{title}}</p>
            <!-- <p>总算力{{number}}P</p> -->
        </div>
        <div class="base-3">
            <img class="img c-img" :src="require(`@/assets/images/computility/blueDrill.png`)" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        title: {
            type: [String],
            default: ''
        },
        title2:{
            type: [String],
            default: ''
        },
        isShow:{
            type: [Boolean],
            default: false
        },
        number: {
            type: [String],
            default: '0'
        },
        number1: {
            type: [String],
            default: '0'
        },
        z_index: {
            type: [Number,String],
            default: 0
        },
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.blueBg1{
    position: absolute;
    top: 20px;
    left: 50px;
    background: url(~@/assets/images/computility/sh-pd.png) no-repeat;
    background-size: 100% 100%;
    padding: 10px 8px;
    font-size: 22px;
}
.blueBg{
    position: absolute;
    top: -20px;
    background: url(~@/assets/images/computility/wh-nj-sh-zj.png) no-repeat;
    background-size: 100% 100%;
    padding: 10px 8px;
    font-size: 22px;
}
.base-2,.base-3{
    .c-img{
        position: absolute;
        top: 0;
        left: 30px;
    }
}
.base-3{
    position: absolute;
    top: 60px;
    left: 140px;
    width: 150px;
    height: 150px;
    background: url(~@/assets/images/computility/blueBase.png) no-repeat;
    background-size: 80% 80%;
}

img{
    animation: Beating 1.2s ease infinite;
}

@keyframes Beating {
    0%{
        transform: translateY(0);
    }
    50%{
        transform: translateY(5px);
    }
    100%{
        transform: translateY(0);
    }
}
</style>